import { gql } from '@apollo/client'

export default gql(`
mutation batchDeleteContentPlaceHolder($deleteInput: [DeleteContentPlaceHolderInput] $project: String){
    batchDeleteContentPlaceHolder(input: $deleteInput project: $project){
      id
    }
  }`
)
